<form #changePasswordForm="ngForm" class="form-vehicle">

  <!-- Password -->
  <div class="form-group mb-2">
    <label translate>global.password</label>
    <input type="password" #password="ngModel" required autocomplete="off" ngModel class="form-control" name="password">
  </div>

  <!-- Confirm Password -->
  <div class="form-group mb-2">
    <label translate>global.confirmPassword</label>
    <input type="password" #password="ngModel" required autocomplete="off" ngModel class="form-control"
      name="passwordRepeat">
  </div>

  <button class="custom_button" (click)="changePassword(changePasswordForm)" translate>Submit</button>
  <button class="custom_button" (click)="onClose()" translate>global.cancel</button>

</form>